import { Spinner } from "reactstrap";
import { loaderStyle } from "../../pages/Common/CommonFunctions/commonFunctions";

const Spiner = (props) => {

    return (
        props.spiner && (
            <div style={loaderStyle}>
              <br></br>
              <br></br>
              <Spinner
                style={{ width: "3.5rem", height: "3.5rem" }}
                className="m-4"
                color="primary"
              />
            </div>
          )
    )
}


export default Spiner;
